module.exports = __webpack_public_path__ + "img/ham.a6436433.svg";